import { Provider } from '@angular/core';

import { runOnFeatureInit } from '@frontend/vanilla/core';

import { BootstrapQuickLink } from './quick-links.bootstrap';

export function provide(): Provider[] {
    return [runOnFeatureInit(BootstrapQuickLink)];
}
